import "core-js/modules/es.array.includes";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.search";
import _objectSpread from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import Vue from "vue";
import createAuth0Client from "@auth0/auth0-spa-js";
/** Define a default action to perform after authentication */

var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK() {
  return window.history.replaceState({}, document.title, window.location.pathname);
};

var instance;
/** Returns the current instance of the SDK */

export var getInstance = function getInstance() {
  return instance;
};
/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */

export var useAuth0 = function useAuth0(_ref) {
  var _ref$onRedirectCallba = _ref.onRedirectCallback,
      onRedirectCallback = _ref$onRedirectCallba === void 0 ? DEFAULT_REDIRECT_CALLBACK : _ref$onRedirectCallba,
      _ref$redirectUri = _ref.redirectUri,
      redirectUri = _ref$redirectUri === void 0 ? window.location.origin : _ref$redirectUri,
      options = _objectWithoutProperties(_ref, ["onRedirectCallback", "redirectUri"]);

  if (instance) return instance; // The 'instance' is simply a Vue object

  instance = new Vue({
    data: function data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null
      };
    },

    /** Use this lifecycle method to instantiate the SDK client */
    created: function created() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$auth0Cli, appState;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return createAuth0Client(_objectSpread(_objectSpread({}, options), {}, {
                  client_id: options.clientId,
                  redirect_uri: redirectUri
                }));

              case 2:
                _this.auth0Client = _context.sent;
                _context.prev = 3;

                if (!(window.location.search.includes("code=") && window.location.search.includes("state="))) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return _this.auth0Client.handleRedirectCallback();

              case 7:
                _yield$_this$auth0Cli = _context.sent;
                appState = _yield$_this$auth0Cli.appState;
                // Notify subscribers that the redirect callback has happened, passing the appState
                // (useful for retrieving any pre-authentication state)
                onRedirectCallback(appState);

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);
                _this.error = _context.t0;

              case 15:
                _context.prev = 15;
                _context.next = 18;
                return _this.auth0Client.isAuthenticated();

              case 18:
                _this.isAuthenticated = _context.sent;
                _context.next = 21;
                return _this.auth0Client.getUser();

              case 21:
                _this.user = _context.sent;
                _this.loading = false;
                return _context.finish(15);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 12, 15, 24]]);
      }))();
    },
    methods: {
      /** Authenticates the user using a popup window */
      loginWithPopup: function loginWithPopup(options, config) {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.popupOpen = true;
                  _context2.prev = 1;
                  _context2.next = 4;
                  return _this2.auth0Client.loginWithPopup(options, config);

                case 4:
                  _context2.next = 9;
                  break;

                case 6:
                  _context2.prev = 6;
                  _context2.t0 = _context2["catch"](1);
                  // eslint-disable-next-line
                  console.error(_context2.t0);

                case 9:
                  _context2.prev = 9;
                  _this2.popupOpen = false;
                  return _context2.finish(9);

                case 12:
                  _context2.next = 14;
                  return _this2.auth0Client.getUser();

                case 14:
                  _this2.user = _context2.sent;
                  _this2.isAuthenticated = true;

                case 16:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 6, 9, 12]]);
        }))();
      },

      /** Handles the callback when logging in using a redirect */
      handleRedirectCallback: function handleRedirectCallback() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3.loading = true;
                  console.log('handleRedirectCallback');
                  _context3.prev = 2;
                  _context3.next = 5;
                  return _this3.auth0Client.handleRedirectCallback();

                case 5:
                  _context3.next = 7;
                  return _this3.auth0Client.getUser();

                case 7:
                  _this3.user = _context3.sent;
                  _this3.isAuthenticated = true;
                  _context3.next = 14;
                  break;

                case 11:
                  _context3.prev = 11;
                  _context3.t0 = _context3["catch"](2);
                  _this3.error = _context3.t0;

                case 14:
                  _context3.prev = 14;
                  _this3.loading = false;
                  return _context3.finish(14);

                case 17:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[2, 11, 14, 17]]);
        }))();
      },

      /** Authenticates the user using the redirect method */
      loginWithRedirect: function loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o);
      },

      /** Returns all the claims present in the ID token */
      getIdTokenClaims: function getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },

      /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
      getTokenSilently: function getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },

      /** Gets the access token using a popup window */
      getTokenWithPopup: function getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },

      /** Logs the user out and removes their session on the authorization server */
      logout: function logout(o) {
        return this.auth0Client.logout(o);
      }
    }
  });
  return instance;
}; // Create a simple Vue plugin to expose the wrapper object throughout the application

export var Auth0Plugin = {
  install: function install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  }
};